import type { Enums } from "../types";

export * from "./get-absence-category-translation-key";
export * from "./get-absence-state-color";
export * from "./get-absence-state-translation-key";
export * from "./get-absence-type-color";
export * from "./get-absence-type-translation-key";
export * from "./get-is-absence-editable";
export * from "./get-vacation-days-accrual-type-translation-key";
export { type AbsenceUserGroup, groupAbsencesByUser } from "./group-absences-by-user";

export const absenceCategories: Enums<"absenceCategory">[] = [
	"vacation",
	"sick",
	"leave",
	"compensation",
] as const;

export const vacationDaysAccrualTypes: Enums<"vacationDaysAccrualType">[] = [
	"monthly",
	"upfront",
] as const;
